@if (facetList$ | async; as facetList) {
  @if (getVisibleActiveFacets(facetList.facets, facetList.activeFacets); as activeFacets) {
    @if (activeFacets && activeFacets.length > 0) {
      <div id="cx-active-facets-groupName">
        {{ 'productList.appliedFilter' | cxTranslate }}
      </div>
    }
    @for (facet of activeFacets; track facet) {
      <a routerLink="./" [queryParams]="getLinkParams(facet)"
        [cxFocus]="{ key: getFocusKey(facetList, facet) }" role="button"
            (keydown.space)="removeFilterWithSpacebar($event)" [attr.aria-label]="
      'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }
    " [attr.title]="
      'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }
    ">
        <span>{{ facet.facetValueName }}</span>
        <cx-icon aria-hidden="true" [type]="closeIcon"></cx-icon>
      </a>
    }
  }
}